import profile from './profile'

export default {
    profile
}



// WEBPACK FOOTER //
// ./src/api/user/index.js